export default function AppLoader() {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-parchment z-[9999]">
      <div className="flex flex-col items-center gap-5">
        <svg
          className="block overflow-visible"
          width="64"
          height="64"
          viewBox="0 0 64 64"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          {/* Outer ring */}
          <circle cx="32" cy="32" r="28" stroke="rgba(232, 224, 212, 0.08)" strokeWidth="2" />
          {/* Spinning arc */}
          <circle
            style={{ transformOrigin: '32px 32px' }}
            className="animate-loader-spin"
            cx="32"
            cy="32"
            r="28"
            stroke="#c8963e"
            strokeWidth="2"
            strokeLinecap="round"
            strokeDasharray="44 132"
          />
          {/* Inner ring */}
          <circle cx="32" cy="32" r="18" stroke="rgba(232, 224, 212, 0.05)" strokeWidth="1.5" />
          {/* Counter-spinning arc */}
          <circle
            style={{ transformOrigin: '32px 32px' }}
            className="animate-loader-spin-reverse"
            cx="32"
            cy="32"
            r="18"
            stroke="rgba(200, 150, 62, 0.45)"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeDasharray="18 95"
          />
          {/* Center dot */}
          <circle cx="32" cy="32" r="3" fill="#c8963e" className="animate-loader-pulse" />
        </svg>
        <p className="font-serif text-[0.9rem] font-medium tracking-[0.12em] text-accent/70 uppercase m-0 animate-loader-fade">
          Legal Hermes
        </p>
      </div>
    </div>
  );
}
